import { SalesDashboardPage } from "@/features/sales-dashboard/pages/SalesDashboardPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/sales-dashboard")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["sales_dashboard.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesDashboardPage,
});
